export default __webpack_public_path__ + "static/media/chain-animated.e791eb82.gif";